const languages = [
  { flag: 'de', code2: 'DE', lang: 'Allemand', country: 'Allemagne' },
  { flag: 'gb', code2: 'EN', lang: 'Anglais', country: 'Royaume-Uni' },
  { flag: 'es', code2: 'ES', lang: 'Espagnol', country: 'Espagne' },
  { flag: 'nl', code2: 'NL', lang: 'Néerlandais', country: 'Pays-Bas' },
  { flag: 'cz', code2: 'CS', lang: 'Tchéque', country: 'République Tchèque' },
  { flag: 'dk', code2: 'DA', lang: 'Danois', country: 'Danemark' },
  { flag: 'fi', code2: 'FI', lang: 'Finlandais', country: 'Finlande' },
  { flag: 'gr', code2: 'EL', lang: 'Grec', country: 'Grèce' },
  { flag: 'hu', code2: 'HU', lang: 'Hongrois', country: 'Hongrie' },
  { flag: 'hr', code2: 'HR', lang: 'Croatie', country: 'Croatie' },
  { flag: 'it', code2: 'IT', lang: 'Italien', country: 'Italie' },
  { flag: 'lt', code2: 'LT', lang: 'Lithuanien', country: 'Lituanie' },
  { flag: 'lv', code2: 'LV', lang: 'Lettonien', country: 'Lettonie' },
  { flag: 'pl', code2: 'PL', lang: 'Polonais', country: 'Pologne' },
  { flag: 'pt', code2: 'PT', lang: 'Portuguais', country: 'Portugal' },
  { flag: 'ro', code2: 'RO', lang: 'Roumain', country: 'Roumanie' },
  { flag: 'sk', code2: 'SK', lang: 'Slovaque', country: 'Slovaquie' },
  { flag: 'si', code2: 'SL', lang: 'Slovenien', country: 'Slovénie' },
  { flag: 'se', code2: 'SV', lang: 'Suédois', country: 'Suède' },
  { flag: 'fr', code2: 'FR', lang: 'Français', country: 'France' },
];

export default languages;
